var map = {
	"./after_1.jpg": 8763,
	"./after_2.jpg": 5964,
	"./after_3.jpg": 105,
	"./after_4.jpg": 4266,
	"./after_5.jpg": 2551,
	"./before_1.jpg": 9484,
	"./before_2.jpg": 8840,
	"./before_3.jpg": 5150,
	"./before_4.jpg": 2485,
	"./before_5.jpg": 4872,
	"./before_6.jpg": 5799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9617;